import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AbileneMarketPerformance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const stats = [{
    value: "97%",
    label: "Occupancy"
  }, {
    value: "24-Hour",
    label: "Maintenance Response"
  }, {
    value: "7",
    label: "AVERAGE DAYS ON MARKET"
  }];
  return <section id="abilene-market-performance" ref={ref} className={cn("py-16 bg-secondary/5 border-y border-border/40 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((stat, i) => <Card key={i} data-index={i} className="bg-background border-none shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-center items-center text-center h-full py-8 md:py-10">
              <CardContent className="p-0 flex flex-col items-center gap-3">
                <span className="font-serif text-4xl font-bold tracking-tight !text-[hsl(0,0%,0%)] md:text-5xl lg:text-6xl">
                  {stat.value}
                </span>
                <span className="font-mono text-sm md:text-base text-muted-foreground uppercase tracking-widest font-medium">
                  {stat.label}
                </span>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}